export const ENHANCED_MEASURES = {
    permissionRequired: {
        enhancedMeasures: 'Permission required',
        bespoke: 'EM_permissionrequired'
    },
    furtherConsultation: {
        enhancedMeasures: 'Further consultation required',
        bespoke: 'EM_furtherconsultationrequired'
    },
    specialGuidance: {
        enhancedMeasures: 'Special guidance required',
        bespoke: 'EM_specialguidancerequired'
    },
    proceedWithCaution: {
        enhancedMeasures: 'Proceed with caution',
        bespoke: 'EM_proceedwithcaution'
    }
    // Active monitoring of searches, not used
};

const ENHANCED_MEASURES_VALUE_TO_VARIANT = {
    'PERMISSION REQUIRED': 'permissionRequired',
    'FURTHER CONSULTATION REQUIRED': 'furtherConsultation',
    'SPECIAL GUIDANCE REQUIRED': 'specialGuidance',
    'PROCEED WITH CAUTION': 'proceedWithCaution'
};

export const ENHANCED_MEASURES_VARIANT_INFO = {
    permissionRequired: {
        titleKey: 'enhancedMeasures.info.permissionRequired',
        defaultTextKey: 'enhancedMeasures.info.permissionRequired.defaultText',
        showBackhandIcon: true
    },
    specialGuidance: {
        titleKey: 'enhancedMeasures.info.specialGuidance',
        defaultTextKey: 'enhancedMeasures.info.specialGuidance.defaultText',
        showBackhandIcon: false
    },
    furtherConsultation: {
        titleKey: 'enhancedMeasures.info.furtherConsultation',
        defaultTextKey: 'enhancedMeasures.info.furtherConsultation.defaultText',
        showBackhandIcon: false
    },
    proceedWithCaution: {
        titleKey: 'enhancedMeasures.info.proceedWithCaution',
        defaultTextKey: 'enhancedMeasures.info.proceedWithCaution.defaultText',
        showBackhandIcon: false
    }
};

export const getEnhancedMeasuresVariant = (value) => {
    if (!value) {
        return null;
    }

    const normalisedValue = String(value).toUpperCase();
    return ENHANCED_MEASURES_VALUE_TO_VARIANT[normalisedValue] || null;
};

export const bespokeCodelist = {
    permissionRequired: ENHANCED_MEASURES.permissionRequired.bespoke,
    furtherConsultation: ENHANCED_MEASURES.furtherConsultation.bespoke,
    specialGuidance: ENHANCED_MEASURES.specialGuidance.bespoke,
    proceedWithCaution: ENHANCED_MEASURES.proceedWithCaution.bespoke
};

export const ENHANCED_MEASURES_CODELIST = {
    permissionRequiredAssets: ENHANCED_MEASURES.permissionRequired.enhancedMeasures,
    furtherConsultationAssets: ENHANCED_MEASURES.furtherConsultation.enhancedMeasures,
    specialGuidanceAssets: ENHANCED_MEASURES.specialGuidance.enhancedMeasures,
    proceedWithCautionAssets: ENHANCED_MEASURES.proceedWithCaution.enhancedMeasures
};
